export default __webpack_public_path__ + "5fbbb6322b0eb8524e488ee5365599c5.png";